export const FETCH_CORRECTION_INCLUDES =
	"custom_fields,items,items.tax,payments,payments.transaction,orders,summary,summary.taxes,recipient,receiver,issuer,linked_invoices,linked_invoices.items,previous_advances,ksef,details";
export const FETCH_CORRECTION_BASE_INVOICE_INCLUDES = "linked_invoices,payments,previous_advances,payments.transaction";
